{
  "allDataFlag": true,
  "list": [
    {
      "agentId": 106889,
      "agentNo": "00038311",
      "agentName": "Andrea Vidová",
      "agentStatus": "FK",
      "agentChannel": "US",
      "agentMobilAgn": "+421907742782",
      "agentEmailAgn": "ekptest@allianz.sk",
      "agentUrl": null,
      "agentItemId": null,
      "uqPolicyId": 1018106837,
      "policyId": 1017233794,
      "policyNumber": "0358253169",
      "dateBegin": "2012-07-03T00:00:00.000+02:00",
      "dateEnd": "2027-07-02T00:00:00.000+02:00",
      "lobId": 7,
      "lobLabel": "LI"
    }
  ]
}
